<script>
  /**@type {string}*/
  export let text;
  /** @type {VoidFunction}*/
  export let callbackAction; 
  /**@type {boolean}*/
  export let invert = false;
  /**@type {"button" | "submit" | "reset"}*/
  export let type= "button";
</script>

<button {type} class="btn-container" class:invert={invert} on:click={callbackAction}>
  <span>{text}</span>
</button>

<style>
  :root {
    --bgColor: #1e2225;
    --color: #fdfdfd;
  }
  .btn-container {
    background-color: var(--bgColor);
    padding: 12px 20px;
    border-radius: 60px;
    border: 1px solid var(--bgColor);
    color: var(--color);
    cursor: pointer;
    text-decoration: none;
    outline: none;
    transition: all 200ms ease;
    box-shadow:
      0 0 40px 40px var(--bgColor) inset,
      0 0 0 0 var(--bgColor);
    text-wrap: nowrap;
    width: 100%;
    max-width: 200px;
  }
  .btn-container span {
    transition: all 200ms ease;
    text-align: center;
    font-size: clamp(0.9rem, 130%, 1.2rem);
    font-family: "gotham-medium";
  }

  .btn-container:hover {
    background: var(--color);
    box-shadow:
      0 0 0px 0 var(--bgColor) inset,
      0 0 0px 2px var(--bgColor);
  }
  .btn-container:hover span {
    color: var(--bgColor);
  }
  .invert{
    background-color: #fdfdfd;
    border: 1px solid #1e2225;
    color: #1e2225;
    box-shadow:
      0 0 40px 40px #fdfdfd inset,
      0 0 0 0 #fdfdfd;
  }
  .invert:hover {
    background: #1e2225;
    box-shadow:
      0 0 0px 0 #fdfdfd inset,
      0 0 0px 2px #fdfdfd;
  }
  .invert:hover span {
    color: #fdfdfd;
  }
  
</style>
